<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalAutoAssinar">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-pencil"></i> Assinar documento
                        <strong>{{file.arquivo_nome}}</strong></p>
                    <button type="button" class="close" @click="closeModal()" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <required /> <label :class="{ 'text-danger': errors.has('Tipo') }"> Tipo de
                                    Assinatura</label>
                                <select v-model="request.assinatura_tipo" :class="{ 'is-invalid': errors.has('Tipo') }"
                                    v-validate="{required:true}" class="form-control" name="Tipo">
                                    <option selected="selected" :value="null">{{$t('words.select')}}</option>
                                    <option value="1">Assinar</option>
                                    <option value="2">Aprovar</option>
                                    <option value="3">Reconhecer</option>
                                    <option value="4">Assinar como parte</option>
                                    <option value="5">Assinar como testemunha</option>
                                    <option value="6">Assinar como interveniente</option>
                                    <option value="7">Acusar recebimento</option>
                                    <option value="8">Dar ciência</option>
                                </select>
                                <div class="invalid-feedback help-block error">{{errors.first('Tipo')}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="request.assinarSemCertificado">
                        <div class="col-md-12">
                            <div class="callout callout-warning">
                                <h6><b><i class="fa fa-exclamation-triangle"></i></b>
                                    O documento será assinado SEM uso do certificado digital próprio.</h6>
                            </div>
                        </div>
                    </div>
                    <div v-if="!request.assinarSemCertificado && display" class="row">
                        <certificate-choice v-if="!error" ref="certificateChoice" :request="request">
                        </certificate-choice>
                        <div v-if="error" class="col-md-12">
                            <div class="alert bg-red alert-dismissible">
                                <h5><b><i class="icon fa fa-exclamation-triangle"></i></b>
                                    {{errorMessage}}</h5>
                                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="callout callout-success">
                                <h6><b><i class="fa fa-shield"></i></b>
                                    O documento será assinado com o certificado digital selecionado.</h6>
                            </div>
                        </div>
                    </div>
                    <p-check :color="appLayout.check" v-model="request.assinarSemCertificado" class="p-switch p-fill">
                        Quero assinar sem certificado
                        digital</p-check>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" @click="closeModal()" class="btn btn-default float-left"><i
                            class="fa fa-times"></i>
                        {{ $t('words.cancel')}}</button>
                    <button type="button" id="signButton" :disabled="loading" @click="sign()"
                        class="btn btn-success float-right"><i class="fa fa-check"></i>
                        Assinar <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import certificateChoice from './certificate-choice.vue';
    export default {
        components: {
            certificateChoice
        },
        data() {
            return {
                error: false,
                errorMessage: null,
                display: false,
                loading: false,
                tokenTipo: 'E',
                request: {
                    id: null,
                    assinatura_tipo: null,
                    assinarSemCertificado: false,
                    file: null,
                    token: null,
                    documento: null,
                    certificate: null,
                },
                file: {}
            }
        },
        methods: {
            closeModal() {
                $('#ModalAutoAssinar').modal('toggle');
                Object.assign(this.$data, this.$options.data());
                this.$validator.reset();
            },
            sign() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) {
                        return;
                    }
                    if (this.request.assinarSemCertificado) {
                        this.submitFile();
                    } else {
                        this.autoAssinarCert();
                    }
                });
            },
            autoAssinarCert() {
                if (!this.$refs.certificateChoice.selectedCert) {
                    toastr({
                        title: 'Selecione um certificado!',
                        icon: 'error'
                    });
                    return;
                }
                if (this.$refs.certificateChoice.getDocument() != this.auth_user.documento && process.env
                    .NODE_ENV == 'production') {
                    toastr({
                        title: 'O certificado não pertence ao usuário logado.',
                        icon: 'warning'
                    });
                    return;
                }
                this.loading = true;
                this.prepareSign();
            },
            prepareSign() {
                this.$store.dispatch('prepareAutoSignFile', this.file.id).then(response => {
                    this.$refs.certificateChoice.token = response.token;
                    this.error = false;
                    this.$refs.certificateChoice.sign().then(response => {
                        this.request.token = this.$refs.certificateChoice.token;
                        this.request.documento = this.$refs.certificateChoice.selectedCert.documento;
                        this.submitFile();
                    }).catch(errorSign => {
                        //erro ao preparar a assinatura (pegar token etc)
                        toastr({
                            title: errorSign,
                            icon: 'error'
                        });
                        console.log(errorSign);
                        this.loading = false;
                    });
                }).catch(error => {
                    this.error = true;
                    this.errorMessage = error.message;
                    this.loading = false;
                });
            },
            submitFile() {
                this.request.file = this.file.id;
                this.loading = true;
                this.$store.dispatch('autoSignFile', this.request).then(response => {
                    toastr({
                        icon: response.status,
                        title: response.message
                    });
                    this.$store.commit('REFRESH_USER_FILES', Math.random().toString(36).substr(2, 5));
                    $('#ModalAutoAssinar').modal('toggle');
                }).catch(error => {
                    toastr({
                        icon: error.status,
                        title: error.message
                    });
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>